module.exports = __webpack_public_path__ + "img/2024122602.d65da9c3.png";